import React, { ChangeEvent, CSSProperties, FC } from 'react'
import styled, { css } from 'styled-components'
import Ripple from 'uiComponents/atoms/Ripple/Ripple'
import {
  complementaryColor,
  fillGreySecondary,
  primaryColor,
} from 'uiComponents/constants/colors'

export const CheckBoxSelector = styled.div`
  position: relative;
  cursor: pointer;
  background-color: transparent;

  ::before {
    opacity: 0 !important;
  }
`
const transitionTiming = '200ms ease'

const HiddenCheckbox = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  z-index: 1;
  cursor: inherit;
`
const StyledCheck = styled.svg`
  display: block;
  transition: opacity ${transitionTiming};
  opacity: 0;
`

const StyledCheckbox = styled.div<{
  checked: boolean
}>`
  cursor: inherit;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  display: block;
  padding: 3px;
  transition: background-color ${transitionTiming},
    box-shadow ${transitionTiming};

  background-color: ${complementaryColor};
  box-shadow: inset 0 0 0 2px ${fillGreySecondary};
  ${props =>
    props.checked &&
    css`
      background-color: ${primaryColor};
      box-shadow: none;

      ${StyledCheck} {
        opacity: 1;
      }
    `};
`

interface ICheckboxProps {
  checkboxStyle?: CSSProperties
  checked: boolean
  checkMarkColor?: 'white' | 'black'
  id?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  withoutRipple?: boolean
}

const Checkbox: FC<ICheckboxProps> = ({
  checkboxStyle,
  checked = false,
  checkMarkColor = 'white',
  id,
  onChange = () => undefined,
  withoutRipple,
}) => {
  const content = (
    <>
      <HiddenCheckbox
        checked={checked}
        id={id}
        onChange={onChange}
        type="checkbox"
      />
      <StyledCheckbox style={checkboxStyle} checked={checked}>
        <StyledCheck viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="none"
            stroke={checkMarkColor}
            strokeWidth="4px"
            d="M1.73,12.91 8.1,19.28 22.79,4.59"
          />
        </StyledCheck>
      </StyledCheckbox>
    </>
  )

  return withoutRipple ? (
    <CheckBoxSelector data-testid="CheckBoxSelector">
      {content}
    </CheckBoxSelector>
  ) : (
    <Ripple as={CheckBoxSelector} rippleTheme="light">
      {content}
    </Ripple>
  )
}

export default Checkbox
